/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { AxiosInstance } from 'axios';
import MockAdapter from 'axios-mock-adapter';
import { addStatisticsMockApi } from './statistics/statisticsMocks';
import { addCompanyMockApi } from './companies/companiesMock';
import { addAuthMockApi } from './auth/authMocks';
import { addAlertsMockApi } from './alerts/alertsMock';
import { addUsersMockApi } from './users/usersMock';
import { addMainStatisticsMockApi } from './mainStatistics/mainStatisticsMock';
import { addDashBoardMockApi } from './dashBoard/dashBoardMock';
import { addCashRegistersMockApi } from './cashRegisters/cashRegistersMocks';
import { addOperatorsMockApi } from './operators/operatorsMocks';
import { addStoreMockApi } from './stores/storesMock';
import { addCashBoxesMockApi } from './cashBoxes/cashBoxesMocks';
import { addDocumentsMockApi } from './documents/documentsMock';
import { addDevicesMockApi } from './devices/devicesMock';
import { addExcelMockApi } from './excelMocks';
import { addReportsByDayMockApi, addReportsMockApi } from './reports/reportsMock';
import { addDownloadingsMockApi } from './downloadings/downloadingsMock';
import { addCashbackMockApi } from './cashback/cashbackMocks';
import { addShortListsMockApi } from './shortLists/shortListsMock';
import { addServiceMockApi } from './service/serviceMocks';

export function createMockAdapter(axiosInstance: AxiosInstance): MockAdapter {
    const mockAdapter = new MockAdapter(axiosInstance);

    // Register your mocks here
    // NOTE: statistics mock should be the first to prevent conflicts with company mocks !!!
    addStatisticsMockApi(mockAdapter);
    addExcelMockApi(mockAdapter);
    addAuthMockApi(mockAdapter);
    addCompanyMockApi(mockAdapter);
    addAlertsMockApi(mockAdapter);
    addUsersMockApi(mockAdapter);
    addMainStatisticsMockApi(mockAdapter);
    addDashBoardMockApi(mockAdapter);
    addCashRegistersMockApi(mockAdapter);
    addOperatorsMockApi(mockAdapter);
    addStoreMockApi(mockAdapter);
    addCashBoxesMockApi(mockAdapter);
    addDocumentsMockApi(mockAdapter);
    addDevicesMockApi(mockAdapter);
    addReportsMockApi(mockAdapter);
    addDownloadingsMockApi(mockAdapter);
    addReportsByDayMockApi(mockAdapter);
    addCashbackMockApi(mockAdapter);
    addShortListsMockApi(mockAdapter);
    addServiceMockApi(mockAdapter);

    // all unmatched requests will create network error
    mockAdapter.onAny().networkError();

    return mockAdapter;
}
